import { Popover, Space, Table } from "antd";
// import moment from "moment";
import { useState, useEffect } from "react";
// import { getApi } from "redux/apis";
import { pageSizeOptionsPaging } from "utils/constant";
import { SortSvgBottom, SortSvgTop } from "utils/svgs";
// import { invalidText, toastText } from "utils/utils";
import SearchAndFilter from "../receiveInventory/SearchAndFilter";
import styles from "./index.module.scss";
import { EditOutlined, ExportOutlined, EyeOutlined } from "@ant-design/icons";
import InventoryDetailsModal from "../receiveInventoryDetailsModel";
import DropdownComponent from "components/Global/Dropdown";
import { getApi } from "redux/apis";
import dayjs from "dayjs";
// import Ellipse from "components/Global/Ellipse";

const { Column } = Table;

interface Props {
  allInventoryData: any[];
  isLoading: boolean;
  onEdit: (inventoryData: any) => void;
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  tableChangeHandler: (pagination: any, filters: any, sorter: any) => void;
  isServiceCenter: boolean;
  isEmployee: boolean;
  searchValue: string;
  performSearchHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchFields: string[];
  handleOk: any;
  handleServiceCenterChange: any;
  selectedServiceCenter: any;
  handleSparePartsChange: any;
  selectedSpareParts: any;
  fetchInventory: any;
  handleFromDateChange: any;
  handleToDateChange: any;
  fromDate: any;
  toDate: any;
  handleSalesOrderNumberChange: any;
  selectedSalesOrderNumbers: any;
  isAdmin?: any;
  sortDirection: any;
  handleStatusChange: any;
  selectedStatus: any;
  expandedRowKeys: any;
  expandedDetails: any;
  expandedPages: any;
  setExpandedRowKeys: any;
  setExpandedDetails: any;
  setExpandedPages: any;
  setFiltersReset: any;
  rowSelection?: any;
  selectedRowKeys?: string[];
  handleDeleteClick?: () => void;
  canDelete?: boolean;
}

const SortingIcon = (data: any) => {
  return data.data.sortOrder === "ascend" ? <SortSvgTop /> : <SortSvgBottom />;
};

const InventoryTable = (props: Props) => {
  const {
    allInventoryData,
    isLoading,
    onEdit,
    currentPage,
    pageSize,
    totalRecords,
    tableChangeHandler,
    isServiceCenter,
    isEmployee,
    searchValue,
    performSearchHandler,
    searchFields,
    handleOk,
    handleServiceCenterChange,
    selectedServiceCenter,
    handleSparePartsChange,
    selectedSpareParts,
    handleFromDateChange,
    handleToDateChange,
    fromDate,
    toDate,
    fetchInventory,
    handleSalesOrderNumberChange,
    selectedSalesOrderNumbers,
    isAdmin,
    sortDirection,
    handleStatusChange,
    selectedStatus,
    expandedRowKeys,
    // expandedDetails,
    // expandedPages,
    // setExpandedRowKeys,
    setExpandedDetails,
    setExpandedPages,
    setFiltersReset,
    rowSelection,
    selectedRowKeys,
    handleDeleteClick,
    canDelete = false,
  } = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [serviceCenters, setServiceCenters] = useState([]);

  // Filter out fully received items from the display data
  const filteredInventoryData = allInventoryData.filter((item) => {
    // Only show items that are not fully received (IN_TRANSIT, SHIPPED, or partial)
    return item.status !== "RECEIVED";
  });

  useEffect(() => {
    const fetchServiceCenters = async () => {
      try {
        const response = await getApi("/serviceCenter/shipment-dropdown");
        if (response.data.success) {
          const formattedCenters = response.data.data.map((center: any) => ({
            value: center.id,
            label: center.name,
          }));
          setServiceCenters(formattedCenters);
        }
      } catch (error) {
        console.error("Failed to fetch service centers:", error);
      }
    };

    fetchServiceCenters();
  }, []);

  // Effect to clean up expanded details when selection changes
  useEffect(() => {
    if (expandedRowKeys.length === 0) {
      setExpandedDetails({});
      setExpandedPages({});
    }
  }, [expandedRowKeys, setExpandedDetails, setExpandedPages]);

  // Handle modal close and refresh data
  const handleModalClose = () => {
    setModalVisible(false);
    // Refresh the inventory data when modal closes to reflect any status changes
    fetchInventory();
  };

  // Handle successful item updates from modal
  const handleItemUpdate = () => {
    // Refresh the main table data when items are updated in the modal
    fetchInventory();
  };
  console.log("11111111111111", serviceCenters);

  return (
    <div className={styles["inventory-table__wrapper"]}>
      <div className={styles["dropdown__wrapper"]}>
        <DropdownComponent
          options={
            serviceCenters.length > 1
              ? [{ value: "all", label: "All" }, ...serviceCenters]
              : serviceCenters
          }
          placeholder="Select Service Center"
          value={
            serviceCenters.length === 0
              ? []
              : serviceCenters.length === 1
              ? [serviceCenters[0].value]
              : selectedServiceCenter && Array.isArray(selectedServiceCenter)
              ? selectedServiceCenter
              : []
          }
          onChange={handleServiceCenterChange}
          isLoading={isLoading}
        />
      </div>
      <SearchAndFilter
        performSearchHandler={performSearchHandler}
        searchValue={searchValue}
        searchFields={searchFields}
        isServiceCenter={isServiceCenter}
        handleServiceCenterChange={handleServiceCenterChange}
        selectedServiceCenter={selectedServiceCenter}
        handleSparePartsChange={handleSparePartsChange}
        selectedSpareParts={selectedSpareParts}
        handleFromDateChange={handleFromDateChange}
        handleToDateChange={handleToDateChange}
        onApply={handleOk}
        fromDate={fromDate}
        toDate={toDate}
        handleSalesOrderNumberChange={handleSalesOrderNumberChange}
        selectedSalesOrderNumbers={selectedSalesOrderNumbers}
        fetchInventory={fetchInventory}
        handleStatusChange={handleStatusChange}
        selectedStatus={selectedStatus}
        setFiltersReset={setFiltersReset}
        handleDeleteClick={handleDeleteClick}
        selectedRowKeys={selectedRowKeys}
        canDelete={canDelete}
      />
      <Table
        dataSource={filteredInventoryData} // Use filtered data instead of allInventoryData
        rowKey={(record) => record.id}
        loading={isLoading}
        scroll={{ y: "calc(100vh - 490px)", x: "63vh" }}
        onChange={tableChangeHandler}
        rowSelection={rowSelection}
        pagination={{
          total: totalRecords,
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: pageSizeOptionsPaging,
          showSizeChanger: true,
        }}
        className={styles["inventory-table"]}
      >
        <Column
          title="Service Center"
          dataIndex="serviceCenter"
          key="serviceCenter"
          className="bg-white"
          width={"25%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
        />
        <Column
          title="3nStar Sales Order"
          dataIndex="salesOrderNumber"
          key="salesOrderNumber"
          className="bg-white"
          width={"25%"}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
        />
        <Column
          title="Quantity"
          dataIndex="totalQuantity"
          key="totalQuantity"
          className="bg-white"
          width={"20%"}
          render={(text: number, record: any) => {
            // Calculate remaining quantity (total - received)
            const remainingQuantity =
              record.totalQuantity - (record.receivedQuantity || 0);
            return <div>{remainingQuantity}</div>;
          }}
          showSorterTooltip={{ title: "" }}
          defaultSortOrder={sortDirection}
          sorter={() => {
            return null as any;
          }}
          sortDirections={["ascend", "descend", "ascend"]}
          sortIcon={(data) => <SortingIcon data={data} />}
        />

        <Column
          title="Delivery Date"
          dataIndex="deliveryDate"
          key="deliveryDate"
          className="bg-white"
          width={"20%"}
          render={(record: any) => {
            return record ? dayjs(record).format("MM/DD/YYYY") : "";
          }}
        />

        <Column
          title="Actions"
          key="actions"
          className="bg-white"
          width={"10%"}
          render={(record: any) => {
            return (
              <Space size={20}>
                <div
                  className="cursor-pointer flex align-center justify-center"
                  onClick={() => {
                    setCurrentRecord(record);
                    setModalVisible(true);
                  }}
                >
                  <EyeOutlined
                    style={{ fontSize: "22px" }}
                    className="eyeIcon"
                  />
                </div>
              </Space>
            );
          }}
        />
      </Table>

      <InventoryDetailsModal
        visible={modalVisible}
        onClose={handleModalClose} // Use the new handler that refreshes data
        record={currentRecord}
        onEdit={onEdit}
        isAdmin={isAdmin}
        isEmployee={isEmployee}
        onItemUpdate={handleItemUpdate} // Pass callback for item updates
        serviceCenters={
          serviceCenters.length === 1
            ? serviceCenters[0].value
            : selectedServiceCenter
        }
      />
    </div>
  );
};

export default InventoryTable;
